import { UploadOutlined } from '@ant-design/icons';
import { Row, Col, Typography, Button, Form } from 'antd';
import { Formik } from 'formik';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModuleType } from '../../../api/types';
import ModuleSelectField from '../../../components/fields/ModuleSelectField';
import { useThemeComponents } from '../../../themes';
import ImportImages from './ImportImages';

const VehicleModuleSelectorModal = (props: { isShownSelector: boolean }) => {
    const { t } = useTranslation('variantList');
    const [visible, setVisible] = useState<boolean>(false);
    const { Modal } = useThemeComponents();
    const { isShownSelector } = props;

    const onImportClicked = useCallback<React.MouseEventHandler>(
        (e: React.MouseEvent<HTMLElement>) => {
            setVisible(true);
        },
        [setVisible]
    );

    const onDone = useCallback(() => {
        setVisible(false);
    }, [setVisible]);

    return (
        <>
            <Button icon={<UploadOutlined />} onClick={onImportClicked}>
                {t('variantList:importButton')}
            </Button>
            <Modal
                footer={null}
                onCancel={() => {
                    setVisible(false);
                }}
                open={visible}
                title={t('variantList:vehicleModuleSelectorModal.title')}
                width={480}
                centered
            >
                <Formik initialValues={{ moduleId: null }} onSubmit={() => {}}>
                    {({ handleSubmit, values }) => (
                        <Form onSubmitCapture={handleSubmit}>
                            <Row gutter={[14, 14]}>
                                <Col span={24}>
                                    <Typography>{t('variantList:vehicleModuleSelectorModal.content')}</Typography>
                                </Col>
                                {isShownSelector && (
                                    <Col span={24}>
                                        <ModuleSelectField
                                            {...t('variantList:vehicleModuleSelectorModal.fields.module', {
                                                returnObjects: true,
                                            })}
                                            moduleType={ModuleType.SimpleVehicleManagement}
                                            name="moduleId"
                                        />
                                    </Col>
                                )}
                                <Col span={24} style={{ textAlign: 'center' }}>
                                    <ImportImages
                                        disabled={!values.moduleId && isShownSelector}
                                        moduleId={values.moduleId}
                                        onDone={onDone}
                                    />
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
};

export default VehicleModuleSelectorModal;
